import { useEffect } from 'react';

/**
 * Calls a callback whenever the browser window is resized.
 * The listener is automatically cleaned up when the component unmounts.
 */
export function useWindowResize(callback: VoidFunction) {
    useEffect(() => {
        window.addEventListener('resize', callback);
        return () => {
            window.removeEventListener('resize', callback);
        };
    });
}
